'use strict';

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};

  var defaultSettings = {
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    container: '#AjaxinateLoop',
    offset: 0,
    loadingText: '',
    callback: null
  };

  this.settings = Object.assign(defaultSettings, settings);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.loadingElement = document.getElementById('loading-animation');

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.loadMore = this.loadMore.bind(this);
  this.destroy = this.destroy.bind(this);

  this.initialize();
};

Ajaxinate.prototype.initialize = function initialize() {
  if (this.containerElement && this.paginationElement) {
    var methods = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    methods[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addScrollListeners() {
  document.addEventListener('scroll', this.checkIfPaginationInView);
  window.addEventListener('resize', this.checkIfPaginationInView);
  window.addEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.addClickListener = function addClickListener() {
  this.nextPageLinkElement = this.paginationElement.querySelector('a');
  this.clickActive = true;

  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.stopMultipleClicks = function stopMultipleClicks(event) {
  event.preventDefault();

  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;

    this.loadingElement.style.display = 'block'; // Show spinner
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function checkIfPaginationInView() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;

  // alert("...ddd");

  if (top <= window.innerHeight) {
    this.removeScrollListener();
    this.nextPageLinkElement = this.paginationElement.querySelector('a');

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;

      this.loadingElement.style.display = 'block'; // Show spinner
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function loadMore() {
  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        var parser = new DOMParser();
        var newDoc = parser.parseFromString(xhr.responseText, 'text/html');
        var newContainer = newDoc.querySelector(this.settings.container);
        var newPagination = newDoc.querySelector(this.settings.pagination);

        if (newContainer) {
          this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
        }

        if (newPagination) {
          this.paginationElement.innerHTML = newPagination.innerHTML;
          this.loadingElement.style.display = 'none'; // Hide spinner
          this.initialize(); // Reinitialize to set event listeners on new content
        } else {
          this.paginationElement.remove(); // Remove pagination if no more pages
          this.loadingElement.style.display = 'none'; // Hide spinner
        }

        if (this.settings.callback && typeof this.settings.callback === 'function') {
          this.settings.callback(newDoc);
        }
      } else {
        console.error('Failed to load more content. Status:', xhr.status);
        this.loadingElement.style.display = 'none'; // Hide spinner on error
      }
    }
  }.bind(this);

  xhr.open('GET', this.nextPageUrl);
  xhr.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickListener() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.removeScrollListener = function removeScrollListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function destroy() {
  var methodDestroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };

  methodDestroyers[this.settings.method]();
};

